import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group text-main flex size-[40px] -rotate-90 cursor-pointer items-center justify-center transition-colors duration-150 md:size-[50px]',
    icon: 'flex size-6 items-center justify-center',
    arrow: 'group-hover:[&>path]:stroke-icon-brand'
  },
  variants: {
    disabled: {
      true: 'hidden'
    },
    left: {
      true: 'rotate-90 justify-center'
    }
  }
});
